import React from "react";
import * as S from "./styles";
import { Grid, useTheme, useMediaQuery } from "@material-ui/core";
import { parseISO, format, differenceInCalendarDays, isValid } from "date-fns";
import BusStep from "../BusStep/";
import { pt } from "date-fns/locale";

// Helper: parseISO seguro que não quebra com datas inválidas
const safeParse = (dateStr) => {
  if (!dateStr || dateStr === "Invalid Date") return null;
  try {
    const parsed = parseISO(dateStr);
    return isValid(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

// Helper: format seguro que retorna fallback se data inválida
const safeFormat = (dateStr, formatStr, options = {}) => {
  const parsed = safeParse(dateStr);
  return parsed ? format(parsed, formatStr, options) : "N/A";
};

const BusSegmentOption = ({ bus, company }) => {
  const theme = useTheme();
  const downOfXs = useMediaQuery(theme.breakpoints.down("xs"));

  // Define busData ANTES de usar em cálculos
  let busData = bus?.bus || bus || {};
  console.log("bus", busData);

  const diffDays = differenceInCalendarDays(
    new Date(busData?.departArrivalDate || 0),
    new Date(busData?.departDate || 0)
  );

  const diffDaysReturn = differenceInCalendarDays(
    new Date(busData?.returnArrivalDate || 0),
    new Date(busData?.returnDate || 0)
  );

  return (
    <S.BusSegmentOption className={`${bus ? "not-unique" : ""}`}>
      {downOfXs ? (
        <Grid container>
          <S.GridItemFlex item xs={12}>
            {busData.departDate && busData.departDate !== "Invalid Date" &&
              safeFormat(busData.departDate, "dd MMMM", { locale: pt })}
          </S.GridItemFlex>
          <S.GridItemFlex item xs={2}>
            <span className="company-name">{company || "N/A"}</span>
          </S.GridItemFlex>
          <S.GridItemFlex item xs={2}>
            <span className="departure-date">
              {busData.departDate && busData.departDate !== "Invalid Date"
                ? safeFormat(busData.departDate, "HH:mm")
                : "N/A"}
            </span>
          </S.GridItemFlex>
          <S.GridItemFlex className="select-option" item xs={2}>
            <span className="arrival-date">
              {busData.departArrivalDate && busData.departArrivalDate !== "Invalid Date"
                ? safeFormat(busData.departArrivalDate, "HH:mm")
                : "N/A"}
              <span className="plus-day">
                {diffDays > 0 ? `+${diffDays}` : ""}
              </span>
            </span>
          </S.GridItemFlex>
          <BusStep
            steps={busData}
            departDate={busData.departDate}
            departArrivalDate={busData.departArrivalDate}
          />
          {busData.returnDate && busData.returnDate !== "Invalid Date" && (
            <>
              <S.GridItemFlex item xs={12}>
                {safeFormat(busData.returnDate, "dd MMMM", { locale: pt })}
              </S.GridItemFlex>
              <S.GridItemFlex item xs={2}>
                <span className="company-name">{company || "N/A"}</span>
              </S.GridItemFlex>
              <S.GridItemFlex item xs={2}>
                <span className="departure-date">
                  {safeFormat(busData.returnDate, "HH:mm")}
                </span>
              </S.GridItemFlex>
              <S.GridItemFlex className="select-option" item xs={2}>
                <span className="arrival-date">
                  {busData.returnArrivalDate && busData.returnArrivalDate !== "Invalid Date"
                    ? safeFormat(busData.returnArrivalDate, "HH:mm")
                    : "N/A"}
                  <span className="plus-day">
                    {diffDaysReturn > 0 ? `+${diffDaysReturn}` : ""}
                  </span>
                </span>
              </S.GridItemFlex>
              <BusStep
                steps={busData}
                departDate={busData.returnDate}
                departArrivalDate={busData.returnArrivalDate}
              />
            </>
          )}
        </Grid>
      ) : (
        <Grid container>
          <S.GridItemFlex item xs={12}>
            {busData.departDate && busData.departDate !== "Invalid Date" &&
              safeFormat(busData.departDate, "dd MMMM", { locale: pt })}
          </S.GridItemFlex>
          <S.GridItemFlex item lg={1} md={1} sm={1} xs={1}>
            <span className="company-name"> {company || "N/A"}</span>
          </S.GridItemFlex>
          <S.GridItemFlex item lg={2} md={2} sm={2} xs={2}>
            <span className="departure-date">
              {busData.departDate && busData.departDate !== "Invalid Date"
                ? safeFormat(busData.departDate, "HH:mm")
                : "N/A"}
            </span>
          </S.GridItemFlex>
          <S.GridItemFlex item lg={4} md={4} sm={4} xs={4}>
            <BusStep
              steps={busData}
              departDate={busData.departDate}
              departArrivalDate={busData.departArrivalDate}
            />
          </S.GridItemFlex>
          <S.GridItemFlex item lg={2} md={2} sm={2} xs={2}>
            <span className="arrival-date">
              {busData.departArrivalDate && busData.departArrivalDate !== "Invalid Date"
                ? safeFormat(busData.departArrivalDate, "HH:mm")
                : "N/A"}
            </span>
          </S.GridItemFlex>

          {busData.returnDate && busData.returnDate !== "Invalid Date" && (
            <>
              <S.GridItemFlex item xs={12}>
                {safeFormat(busData.returnDate, "dd MMMM", { locale: pt })}
              </S.GridItemFlex>
              <S.GridItemFlex item lg={1} md={1} sm={1} xs={1}>
                <span className="company-name"> {company || "N/A"}</span>
              </S.GridItemFlex>
              <S.GridItemFlex item lg={2} md={2} sm={2} xs={2}>
                <span className="departure-date">
                  {safeFormat(busData.returnDate, "HH:mm")}
                </span>
              </S.GridItemFlex>
              <S.GridItemFlex item lg={4} md={4} sm={4} xs={4}>
                <BusStep
                  steps={busData}
                  departDate={busData.returnDate}
                  departArrivalDate={busData.returnArrivalDate}
                />
              </S.GridItemFlex>
              <S.GridItemFlex item lg={2} md={2} sm={2} xs={2}>
                <span className="arrival-date">
                  {busData.returnArrivalDate && busData.returnArrivalDate !== "Invalid Date"
                    ? safeFormat(busData.returnArrivalDate, "HH:mm")
                    : "N/A"}
                </span>
              </S.GridItemFlex>
            </>
          )}
        </Grid>
      )}
    </S.BusSegmentOption>
  );
};

export default BusSegmentOption;
